export default function Callout({ children }){
  return (
    <section className="callout">
        {children}
    </section>
  )
}